import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CHIRP_APP_URL, COGNITO_CLIENT_ID, COGNITO_URL } from 'config';
import { useAuth } from 'contexts/AuthContext';
import { NoopT } from 'declarations/types/common';

type UseLoginT = {
  isLoginLoading: boolean;
  redirectToCognitoLoginPage: NoopT;
  redirectToCognitoForgotPasswordPage: NoopT;
};

const useLogin = (): UseLoginT => {
  /**
   * Hooks
   */
  const { login, isLoginLoading } = useAuth();
  const [search] = useSearchParams();

  /**
   * Variables
   */
  const codeSearchParam = search.get('code');

  /**
   * Handlers
   */
  const redirectToCognitoLoginPage = () => {
    window.location.href = `${COGNITO_URL}/login?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${CHIRP_APP_URL}/login`;
  };
  const redirectToCognitoForgotPasswordPage = () => {
    window.location.href = `${COGNITO_URL}/forgotPassword?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${CHIRP_APP_URL}/login`;
  };

  /**
   * Effects
   */
  useEffect(() => {
    if (codeSearchParam) {
      login(codeSearchParam);
    }
  }, [codeSearchParam, login]);

  return { redirectToCognitoLoginPage, redirectToCognitoForgotPasswordPage, isLoginLoading };
};

export default useLogin;
